import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TagInput } from './tag-input';
import { UserService } from '@data/services/user.service';

@Component({

    selector: 'syn-user-tag-input',
    templateUrl: 'tag-input.html',
    styleUrls: ['tag-input.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => UserTagInputComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => UserTagInputComponent), multi: true }
    ]
})
export class UserTagInputComponent extends TagInput {
    constructor(userService: UserService) {
        super(userService);
    }
}
